// Nextmine: iPhone-billeder er ofte HEIC/HEIF, som Chrome m.fl. ikke kan afkode.
// Uden konvertering fejler fritlægningen (canvas-decode) STILLE på første billede,
// og previews kan være blanke. Vi konverterer derfor HEIC → JPEG ved upload, så
// hele kæden (preview, fritlægning, Sharetribe-upload) virker ens overalt.
// Biblioteket (heic2any, wasm ~1 MB) hentes først når en HEIC-fil faktisk vælges.

const isHeicFile = file => {
  const type = (file?.type || '').toLowerCase();
  const name = (file?.name || '').toLowerCase();
  // NB: på macOS rapporterer Chrome ofte tom MIME-type for HEIC - tjek også endelsen.
  return (
    type === 'image/heic' ||
    type === 'image/heif' ||
    name.endsWith('.heic') ||
    name.endsWith('.heif')
  );
};

/**
 * Returns the given file converted to a JPEG File if it is HEIC/HEIF,
 * otherwise returns the file unchanged. Throws if conversion fails -
 * callers decide whether to fall back to the original file.
 *
 * @param {File} file
 * @returns {Promise<File>}
 */
export const ensureJpegFromHeic = async file => {
  if (!isHeicFile(file)) {
    return file;
  }
  const heic2any = (await import('heic2any')).default;
  const result = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 });
  const blob = Array.isArray(result) ? result[0] : result;
  const baseName = (file.name || 'image').replace(/\.[^.]+$/, '');
  return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg' });
};
